import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users.service';
import Swal from 'sweetalert2';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { UserProfile } from 'src/app/models/users/UserProfile';
import { RolesEnum } from 'src/app/models/users/roles/enums/roles';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html'
})
export class UserProfileComponent implements OnInit {
  user!: UserProfile;
  dataLoading = false;
  loading = false;
  actions = RolesEnum;
  
  // image file
  avatar: any;
  avatarSrc!: string;
  maxFileSize = 0.8;
  fileTypeError = false;
  fileSizeError = false;

  constructor(
    private service: UsersService,
    public dialog: MatDialog,
    private auth: AuthenticationService
  ) { }

  ngOnInit() {
    this.auth.currentUserSubject.subscribe(user => {
      if (user) {
        this.getDetails();
      }
    });
  }

  getDetails(reload = true) {
    this.dataLoading = reload;
    this.service.getUserProfileDetails().subscribe(
      data => {
        this.dataLoading = false;
        if (data) {
          this.user = data as UserProfile;
          this.clear();
        }
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '540px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result);
      }
    });
  }

  // File preview with validation
  uploadAvatar($event: any): void {
    const file: File = $event.target.files[0];
    if (file && this.validateFile(file)) {
      this.readThis(file);
      this.avatar = file;
    } else {
      this.clear();
    }
  }
  readThis(file: File): void {
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      // this.user.userImage = myReader.result as string;
      this.avatarSrc = myReader.result as string;
    };
  }
  validateFile(file: File): any {
    if (this.fileType(file.name)) {
      this.fileTypeError = false;
      if ((file.size / (1024 * 1024)) <= this.maxFileSize) {
        this.fileSizeError = false;
      } else {
        this.fileSizeError = true;
        return false;
      }
    } else {
      this.fileTypeError = true;
      return false;
    }
    return true;
  }
  fileType(fileName: any): any {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }

  updateAvatar() {
    if (this.avatarSrc) {
      this.loading = true;
      const formData = new FormData();
      formData.append('image', this.avatar, this.avatar.name);
      this.service.uploadUserPicture(formData).subscribe(() => {
        this.loading = false;
        this.getDetails(false);
        Swal.fire({
          title: 'Success',
          text: 'Updated Successfully',
          icon: 'success',
          confirmButtonText: 'Ok',
        }).then(() => {
        });
      }, err => {
        this.loading = false;
      });
    }
  }

  clear() {
    this.avatarSrc = this.user.profileDetails.imagePath;
    this.avatar = undefined;
  }

  hasPermission(permission: string) {
    return this.auth.hasPermission(permission);
  }

}
